export default class CouldNotSignUpError extends Error {
  constructor(message) {
    super(message);
    Object.setPrototypeOf(this, CouldNotSignUpError.prototype);
  }
}
